import { lazy } from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { DomainRoute } from '../utils/domain/routingComponents'
import { shiftsAccessControl } from '../access-control/shiftsAccess.configuration'

const ShiftManagementPage = lazy(
  () =>
    /* webpackChunkName: "ShiftManagementPage" */
    import('../pages/ShiftManagement/page')
)
const CSVHistoryPage = lazy(
  () =>
    /* webpackChunkName: "CSVHistoryPage" */
    import('../pages/CSVHistory/page')
)
// @hygen:inject page-import

export const shiftsRouter = (
  <DomainRoute route="shifts" accessControl={shiftsAccessControl}>
    <DashSwitch>
      <DomainRoute exact route="csvHistory" component={CSVHistoryPage} />
      <DomainRoute exact route="shifts" component={ShiftManagementPage} />
      {/* @hygen:inject router-route 
        injection point for routes, please do not delete */}
    </DashSwitch>
  </DomainRoute>
)
